
import React from "react";
import { Container , Row , Col } from "reactstrap";
import './Treandingsection.css';
import { Link } from "react-router-dom";
import { NFT__DATA } from './../../../assets/data/data';
import Nftcards from './../Nftards/Nftcards';

function  TreandingSection  ()  {

    return(
        <section>
            <Container>
                <Row>
                    <Col  lg="12">
                        <h3  className="trending__title"> Trending  </h3>

                    </Col>
                    {
                        NFT__DATA.slice(0,8).map((item) => {
                            return(
                                <Col  key={item.id}  lg="3" md="4" sm="6"  className="mb-4" >
                                    <Nftcards  item={item} /> 

                                </Col>
                            );

                        })
                    }


                </Row>
            </Container>

        </section>
    );
}

export default TreandingSection;
